<template>
    <b-row id="cover-my-meds" v-if="status.length > 0">
        <b-col>
            <b-row cols="1">
                <b-col><h4>{{displayValue}}</h4></b-col>
                <b-col><h5>Cover My Meds Response:</h5></b-col>
                <b-col><strong>Message: </strong>{{message}}</b-col>
                <b-col><strong>Status: </strong>{{status}}</b-col>
                <b-col v-if="cmmResponse.error"><strong>Error: </strong>{{cmmResponse.error}}</b-col>
            </b-row>
            <CoverMyMedsButtonsComponent v-model="cmmResponse"></CoverMyMedsButtonsComponent>
        </b-col>
    </b-row>
</template>

<script lang="ts">
    import {VModel, Vue, Component, Prop} from "vue-property-decorator";
    import {CoverMyMedsResponse} from "@/models/PriorAuthorization";
    import CoverMyMedsButtonsComponent from "@/components/PriorAuthorization/CoverMyMedsButtonsComponent.vue";

    @Component({
        components: {
            CoverMyMedsButtonsComponent,
        }
    })
    export default class CoverMyMedsResponseComponent extends Vue {
        @VModel() private cmmResponse!: CoverMyMedsResponse;
        @Prop({default: "", type: String}) private displayValue!: string;

        get status() {
            return this.cmmResponse?.status ?? "";
        }
        get message() {
            return this.cmmResponse?.message ?? "";
        }
    }
</script>

<style scoped>
</style>
